/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Beach',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            fillRule="evenodd"
            d="M15.546.949a.6.6 0 0 1 .359.768l-.424 1.168c4.487 1.943 6.864 6.894 5.603 11.592-.088.327-.532.377-.754.121-.495-.572-1.14-1.03-1.902-1.307-1.144-.415-2.347-.347-3.383.1l-.091.028c-.184.037-.379-.043-.486-.197l-.046-.083a4.23 4.23 0 0 0-1.908-2.091c-.003.011-.004.022-.008.033l-4.22 11.613a.6.6 0 0 1-1.128-.41l4.22-11.613c.004-.011.01-.021.014-.031a4.23 4.23 0 0 0-2.81.379l-.09.035a.48.48 0 0 1-.551-.242c-.508-1.008-1.386-1.833-2.53-2.249a4.57 4.57 0 0 0-2.293-.218l-.062.005c-.309.008-.571-.293-.437-.582 2.049-4.411 7.049-6.682 11.736-5.29l.424-1.167a.6.6 0 0 1 .768-.359zm-2.987 2.176c-3.284-.377-6.527 1.125-8.363 3.87-.085.128.006.298.159.312a5.6 5.6 0 0 1 1.397.313l.258.101a5.55 5.55 0 0 1 2.19 1.657c.816-1.997 1.834-3.708 2.881-4.913.478-.549.976-1.008 1.478-1.34zm3.878 1.409c.172.577.26 1.249.274 1.977.03 1.594-.287 3.557-.942 5.61.97-.194 2.004-.133 3.001.229a5.6 5.6 0 0 1 1.276.659c.126.087.305.015.321-.138.353-3.284-1.169-6.518-3.929-8.337zm-1.924-.744c-.233-.085-.564-.067-1.017.171s-.97.67-1.51 1.291c-.918 1.055-1.845 2.588-2.61 4.419a5.22 5.22 0 0 1 2.931.19l.264.104c.858.365 1.571.936 2.104 1.633.59-1.896.863-3.667.837-5.066-.016-.824-.135-1.486-.329-1.96s-.436-.699-.669-.783z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
